<template>
  <div :class="['file-item-container', isCancelOrFail ? 'cancel-or-fail-border-color' : '']">
    <template v-if="!isCancelOrFail">
      <div class="starting" :style="{ width: process }"></div>
      <div class="no-start"></div>
    </template>

    <div v-else class="cancel-or-fail-bg-color"></div>
    <div class="content">
      <div class="left">
        <i
          :class="[
            fileType === 'upload' ? 'el-icon-upload2' : 'el-icon-download',
            'el-icon1',
            isCancelOrFail ? 'cancel-or-fail-icon-color' : ''
          ]"
        ></i>
        <div class="file-info">
          <p class="info-style" title="66">{{ title }}</p>
          <p class="info-style" title="66">{{ time }}</p>
        </div>
      </div>
      <div class="right">
        <template v-if="type === 'progressing'">
          <div v-if="isNum" class="percent">{{ process }}</div>
          <div class="cancel" @click="handleCancel">取消</div>
        </template>
        <template v-else>
          <div><i class="el-icon-close" @click="handleDelete"></i></div>
          <p v-if="type === 'success'" class="success">已完成</p>
          <p v-if="type === 'canceled'" class="canceled">已取消</p>
          <p v-if="type === 'failed'" class="failed">已失败</p>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
import '../../../../lib/styles/components/FileItem.scss'
export default {
  name: 'FileItem',
  props: {
    // 文件名称
    title: {
      type: String,
      required: true
    },
    // 时间
    time: {
      type: String,
      required: true
    },
    // 文件上传下载类型  upload / download
    fileType: {
      type: String,
      default: 'upload'
    },
    // 当前状态  progressing：进行中  canceled：已取消  failed：失败  success：已完成
    type: {
      type: String,
      default: 'progressing'
    },
    // 进度 百分比字符串
    process: {
      type: String,
      required: true
    },
    // 显示进度文字
    isNum: {
      type: Boolean,
      default: false
    },
    // 当前文件信息对象
    infoItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      progressVal: '50%'
    }
  },
  computed: {
    // 是否是已取消或已失败
    isCancelOrFail() {
      return this.type === 'canceled' || this.type === 'failed'
    }
  },
  methods: {

    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    handleCancel() {
      this.$emit('cancel', this.infoItem)
    },
    handleDelete() {
      this.$emit('delete', this.infoItem)
    }
  }
}
</script>
